import { useAnnouncementList } from "../../hooks/api/v2/announcement/useAnnouncementList";
import { useNotificationList } from "../../hooks/api/v2/notification/useNotificationList";

export const NOTIFICATION_BADGE_LIMIT = 10;

export const useRetailerNotificationSummary = () => {
  const polling = {
    refetchInterval: 10 * 60 * 1000,
    refetchIntervalInBackground: false,
  };
  const notifications = useNotificationList(
    {
      query: [
        { type: "priority", value: "high", modifier: "EQUALS" },
        { type: "unRead", value: true, modifier: "EQUALS" },
      ],
      limit: NOTIFICATION_BADGE_LIMIT + 1,
    },
    polling,
  );
  const announcements = useAnnouncementList(
    {
      query: [{ type: "unRead", value: true, modifier: "EQUALS" }],
      limit: NOTIFICATION_BADGE_LIMIT + 1,
    },
    polling,
  );
  const count =
    (notifications.data?.pages[0]?.length ?? 0) +
    (announcements.data?.pages[0]?.length ?? 0);
  const countReady =
    !notifications.isPending &&
    !announcements.isPending &&
    !notifications.isError &&
    !announcements.isError;
  return {
    notifications,
    announcements,
    hasUnread: count > 0,
    unreadCount: countReady
      ? Math.min(count, NOTIFICATION_BADGE_LIMIT + 1)
      : undefined,
  };
};

export const useRetailerNotificationIndicator = () =>
  useRetailerNotificationSummary().hasUnread;
